import React from 'react';
import { useTranslation } from 'react-i18next';
import { validateMappedOutput } from '../schema-builder/validation';
import { HEADER_CLASSES } from './styles';

// What the mapping produces from the sample, with any validation errors on top.
const OutputPreview = ({
  hasMappings,
  output,
  errors,
}: {
  hasMappings: boolean;
  output: any;
  errors: ReturnType<typeof validateMappedOutput>;
}) => {
  const { t } = useTranslation();
  return (
    <div className="mt-3 flex flex-col overflow-hidden rounded-lg border border-ui-divider-lines">
      <div className={`${HEADER_CLASSES} flex-shrink-0`}>
        <span>{t('Output Preview')}</span>
        {!hasMappings && (
          <span className="text-body-sm font-normal text-ui-text-primary-text">
            {t('Map some fields to see output')}
          </span>
        )}
      </div>
      {hasMappings && errors.length > 0 && (
        <div className="border-b border-ui-divider-lines bg-ui-status-bg-error-bg px-4 py-3">
          <p className="mb-1.5 text-body-sm font-bold text-ui-status-error-destructive">
            {t('Validation errors')}
          </p>
          <ul className="flex flex-col gap-1">
            {errors.map((error, index) => (
              <li
                key={index}
                className="flex items-center gap-1.5 text-body-sm text-ui-text-primary-text"
              >
                <span className="font-mono text-ui-status-error-destructive">
                  {error.field}
                </span>
                <span className="text-ui-text-primary-text">—</span>
                <span>
                  {String(
                    t(error.messageKey as any, error.messageParams as any),
                  )}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <pre
        data-testid="JqFilterBuilder-output-preview"
        className="m-0 min-h-[60px] whitespace-pre-wrap bg-teal-t10 p-4 font-mono text-body-sm leading-relaxed text-ui-text-primary-text"
      >
        {hasMappings ? JSON.stringify([output], null, 2) : ''}
      </pre>
    </div>
  );
};

export default OutputPreview;
